module.exports = __webpack_public_path__ + "static/arrow_3-8bd9cf724395ea9cee8ef2d37d63583d.png";